<template>
  <div class="videoList" v-if="!isEmpty(firstVideo)">
    <div class="container" id="videoButton">
      <button @click="backToHome">{{ $t("label.categories") }}</button>
    </div>
    <div
      class="cover d-flex align-items-center justify-content-center videoPlayer"
      v-html="getFirstVideoPlayEmebed"
      v-if="!isEmpty(getFirstVideoPlayEmebed)"
    >
      <!-- <div v-html="firstVideo.playerembed"></div> -->
      <!-- <strong>SCIENCE</strong> VIDEO -->
    </div>
    <div class="container" id="videoDetail">
      <div>
        <h3 v-html="getFirstVideoTitle" />
        <div v-html="getFirstVideoDesc" />
        <div v-if="!isEmpty(cateInfo.answers)">
          <div class="row">
            <category-content
              :videoInfo="video"
              v-for="video in getVideos"
              :key="video.slug"
              class="col-6 col-sm-3 col-md-3"
              @videoSelected="videoOtherClick"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { find, isEmpty, filter, some, get } from "lodash";
import CategoryContent from "@/components/CategoryContent.vue";
import $ from "jquery";
export default {
  data: () => ({
    cateInfo: {},
    firstVideo: {},
  }),
  components: {
    CategoryContent,
  },
  computed: {
    ...mapState({
      categories: "categories",
      answerSelected: "answerSelected",
    }),
    getVideos() {
      return filter(
        this.cateInfo.answers,
        (video) => video.slug !== this.firstVideo.slug
      );
    },
    locale() {
      return this.$i18n.locale;
    },
    getFirstVideoPlayEmebed() {
      return get(this.firstVideo, `${this.locale}.playerembed`);
    },
    getFirstVideoTitle() {
      return get(this.firstVideo, `${this.locale}.title`);
    },
    getFirstVideoDesc() {
      return get(this.firstVideo, `${this.locale}.description`);
    },
  },
  watch: {
    $route: {
      async handler(val) {
        await this.doInitData(val.params.slug);
      },
      immediate: true,
    },
  },
  methods: {
    isEmpty,
    videoOtherClick(videoId) {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.firstVideo = find(
        this.cateInfo.answers,
        (item) => item.id === videoId
      );
    },
    backToHome() {
      this.$router.push({
        name: "Home",
        params: {
          locale: this.locale,
        },
      });
    },
    async doInitData(slug) {
      try {
        if (isEmpty(this.categories)) {
          await this.$store.dispatch("fetchCategories", {});
        }
        const category = find(
          this.categories,
          (category) => category.slug === slug
        );
        if (!isEmpty(category)) {
          this.cateInfo = category;
          if (
            some(
              category.answers,
              (answer) => answer.id === this.answerSelected.id
            )
          ) {
            this.firstVideo = this.answerSelected;
          } else {
            this.firstVideo = category.answers[0];
          }
          this.$nextTick(() => {
            let padding = "10px";
            let iframeWidth = 935;
            if (!isEmpty(this.getFirstVideoPlayEmebed)) {
              iframeWidth = $(".videoPlayer iframe").width();
              padding = "10px 0";
            }
            if ($(window).width() >= iframeWidth) {
              padding = "inital";
            }
            $("#videoDetail").css({
              maxWidth: iframeWidth + "px",
              padding,
            });
            $("#videoButton").css({
              maxWidth: iframeWidth + "px",
              paddingBottom: "10px",
              paddingLeft: $(window).width() <= iframeWidth ? "10px" : 0,
            });
          });
        }
      } catch (error) {
        console.error(error);
        this.backToHome();
      }
    },
  },
};
</script>

<style lang="scss" >
.videoList {
  .container {
    // max-width: 90%;
    padding-top: 20px;
    &#videoButton {
      span {
        font-size: 24px;
        line-height: 24px;
        vertical-align: middle;
        display: inline-block;
        transform: rotate(180deg);
      }
    }
  }
  .cover {
    // background-image: url("/img/cover.png");
    // height: 600px;
    // background-size: cover;
    // background-position: center;
    color: #fff;
    font-size: 30px;

    @media (max-width: 767px) {
      height: 300px;
    }
  }
  .row {
    margin: 0;
    .videoInfo {
      padding-left: 0;
    }
  }
}
</style>
